import i18n from "i18n";
import { useQuery } from "@tanstack/react-query";
import URI from "urijs";
import { getDataLakeUriParams } from "data-lake/logic/Utils";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import { DATA_LAKE_API_ROUTES, DATA_LAKE_INCLUSION_TYPE } from "data-lake/Constants";
import useUserDateTime from "hooks/useUserDateTime";
import { defaultOnError } from "util/conditional/onError";
const fetchEstimate = (params, userTimezone) => {
  const {
    dataLakeId,
    streamIds,
    from,
    to,
    inclusionType = DATA_LAKE_INCLUSION_TYPE,
    fieldFilters = [],
    operator = "AND"
  } = params;
  if (from === "" || to === "" || streamIds.length === 0) {
    return null;
  }
  const uri = new URI(DATA_LAKE_API_ROUTES.DataLakeAPIController.estimate().url).addSearch({ data_lake_id: dataLakeId, stream_ids: streamIds, inclusion_type: inclusionType, operator }).toString();
  return fetch("POST", qualifyUrl(`${uri}&${getDataLakeUriParams({ from, to }, userTimezone)}`), [...fieldFilters]);
};
const useDataLakeEstimate = (params, { enabled } = { enabled: true }) => {
  const { userTimezone } = useUserDateTime();
  const { data, refetch, isInitialLoading } = useQuery({
    queryKey: ["data-lake", "estimate", params],
    queryFn: () => defaultOnError(
      fetchEstimate(params, userTimezone),
      i18n.t("notifications.fetch_estimate_failed", { ns: "enterprise_data_lake" }),
      i18n.t("notifications.fetch_estimate_failed_title", { ns: "enterprise_data_lake" })
    ),
    notifyOnChangeProps: ["data", "error"],
    enabled
  });
  return {
    data,
    refetch,
    isInitialLoading
  };
};
export default useDataLakeEstimate;
